<template>
  <div class="page-container page render">
    <div class="d-flex justify-content-between mb-2">
      <h3>{{ $t('basket.where') }}</h3>
      <NavigateWithSelector
        :latitude="coordinates.lat"
        :longitude="coordinates.lon"
        small
      />
    </div>
    <leaflet-location-picker
      :zoom="zoom"
      :coordinates="coordinates"
      :icon="icon"
      :marker-draggable="false"
    />
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet.awesome-markers'
import LeafletLocationPicker from '@/components/map/LeafletLocationPicker'
import NavigateWithSelector from '@/components/UI/NavigateWithSelector.vue'
L.AwesomeMarkers.Icon.prototype.options.prefix = 'fa'

export default {
  components: { LeafletLocationPicker, NavigateWithSelector },
  props: {
    zoom: { type: Number, required: true },
    coordinates: { type: Object, required: true },
  },
  data () {
    return {
      icon: L.AwesomeMarkers.icon({ icon: 'shopping-basket', markerColor: 'green' }),
    }
  },
}
</script>
